// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selection-group[data-v-5f3fb8ec] {\n  height: 90px;\n}\n.autoscale-label[data-v-5f3fb8ec] label {\n  font-size: 0.75em;\n}", ""]);
// Exports
module.exports = exports;
